
export const RemoteTeam = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-stretch">
          {/* Left side - Text content */}
          <div className="space-y-8 animate-fade-in flex flex-col justify-center">
            <h2 className="text-3xl font-bold text-gray-900">
              Organize remote team fast & easily
            </h2>
            <p className="text-lg text-gray-600">
              Organizing and managing your remote teams has never been this easy!
            </p>
            <div className="space-y-6">
              <div className="space-y-2">
                <h3 className="text-xl font-semibold text-gray-900">Create Unlimited Teams</h3>
                <p className="text-gray-600">
                  Create unlimited teams and boost productivity with efficient collaboration.
                </p>
              </div>
              <div className="space-y-2">
                <h3 className="text-xl font-semibold text-gray-900">Hasslefree Chat with Everyone</h3>
                <p className="text-gray-600">
                  With unique and simple UIs, keep yourself connected across all the teams.
                </p>
              </div>
            </div>
          </div>
          
          {/* Right side - Image */}
          <div className="animate-fade-in h-full flex items-center" style={{ animationDelay: "0.2s" }}>
            <img
              src="https://dynamico.cloud/assets/img/feature4.png"
              alt="Remote Team Features"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
